import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Tab from "../components/tab";
import { 
  returnHome, 
  currentExperience,
} from "../../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { capitalize } from "../../../utils/capitalize/capitalizeWord";

export default function Experience2({ nextStep, prevStep }) {
  // const profile = useSelector(e => e.profile);
  const dispatch = useDispatch();
  
  const exp = useSelector(exp => exp.activities);
  const currentExp = useSelector(exp => exp.currentExperience);
  const secret = useSelector(prev => prev.secret);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  // const existing_cv_data = useSelector((prev) => prev.existingCV);
  // const message = existing_cv_data.message;
  // const profile1 = useSelector(e => e.login);
  // const userInfo = useSelector(e => e.userInfo);


  const [companyName, setCompanyName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (currentExp.message !== null) {
      let where_i_worked = currentExp.message?.Where_i_worked;
      let job_title = currentExp.message?.My_job_title;
      setCompanyName(where_i_worked !== undefined ? where_i_worked: "");
      setJobTitle(job_title !== undefined ? job_title : "");
    } else {
      let cacheInfo = getOneFromServerCache("current_experience")
      cacheInfo.then(res => res.json())
        .then(res => {
          // console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(currentExperience(resObj));
              setCompanyName(resObj?.Where_i_worked);
              setJobTitle(resObj?.My_job_title);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch (error => console.log("Error prefilling the current experience company name and title", error))
    }

  }, []);
  // console.log("company name", companyName)

  const [showCompany, setShowCompany] = useState(false);
  const [showJobTitle, setShowJobTitle] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showCompanyTimeout = setTimeout(() => setShowCompany(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(showCompanyTimeout);
  }, []);

  useEffect(() => {
    if (companyName !== "" && companyName !== undefined && showCompany == true) {
      // Show last name label and input once first name is being typed
      const showJobTitleTimeout = setTimeout(() => setShowJobTitle(true), 500);

      return () => clearTimeout(showJobTitleTimeout);
    }
  }, [companyName, showCompany]); // Runs only when firstName updates

  useEffect(() => {
    if (showCompany == true) {
      // Show last name label and input once first name is being typed
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 500);

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [showCompany]); // Runs only when firstName updates

    /* Moving section */
    const handlePrev = () => {
      prevStep();
    }
  
    const handleNextCall = async () => {
      // handleNext(dispatch, firstName, lastName, nextStep);
      try {
        if (companyName !== "" && companyName !== undefined && jobTitle !== "" && jobTitle !== undefined) {
          let experience = {
            Where_i_worked: capitalize(companyName)?.trim(),
            // Where_i_worked_location: $('[name="work_place"]').val(),
            My_job_title: capitalize(jobTitle)?.trim(),
            Work_start_date: currentExp.message?.Work_start_date,
            Work_end_date: currentExp.message?.Work_end_date,
            Day_to_day_work: currentExp.message?.Day_to_day_work,
            // Review: true,
            Tags: currentExp.message?.Tags
          }
          dispatch(currentExperience(experience));
          // save into server cache
          await saveIntoServerCache("current_experience", experience);
          nextStep();
        } else {
          setTimeout(() => {
              toast.error("A least one job title is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
          }, 50);
        }
      } catch (error) {
          throw error
      }
    }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
          <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <Tab num="2" current={true} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Input Section with Animations */}
        <div className="flex justify-center w-full">
          <div className="flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center">
            
            <motion.p 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut" }} 
              className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold notranslate"
            >
              {exp.activities == null ? 
                <> 
                {flowLanguage == "Spanish" ? (
                  <Typewriter key={flowLanguage} words={["¡Genial! Vamos a agregar tu primer empleo."]} loop={1} typeSpeed={40} />
                ) : (
                  <Typewriter key={flowLanguage} words={["Great! Let's add your first job."]} loop={1} typeSpeed={40} />
                )}</> : 
                <>
                  {flowLanguage == "Spanish" ? (
                    <Typewriter key={flowLanguage} words={["¡Genial! Vamos a agregar otro trabajo."]} loop={1} typeSpeed={40} />
                  ) : (
                    <Typewriter key={flowLanguage} words={["Great! Let's add another job."]} loop={1} typeSpeed={40} />
                  )}
                  </>
              }
            </motion.p>

            <div className="flex lg:w-full vsm:w-full zsm:w-[400px] flex-col lg:flex-row md:gap-8 md:justify-between justify-center">
              
              {/* Company Name Input with Fade-Up & Typing Effect */}
              {showCompany && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
                  className="flex w-full flex-col gap-y-2 vsm:my-6 md:my-0"
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="companyName" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿Cuál era el nombre de la empresa?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What was the company name?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What was the company name?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="companyName"
                        className="w-full md:max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="Type your answer here"
                      />
                    </div>
                  </div>
                </motion.div>
              )}

              {/* Job Title Input with Fade-Up & Typing Effect */}
              {showJobTitle && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                  className="flex w-full flex-col gap-y-2 vsm:my-6 md:my-0"
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="jobTitle" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿Cuál era tu cargo?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What was your job title?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What was your job title?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="jobTitle"
                        className="w-full md:max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.target.value)}
                        placeholder="Type your answer here"
                      />
                      {error && <p className="text-xs text-[#FF6633] font-medium">{error}</p>}
                    </div>
                  </div>
                </motion.div>
              )}

            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                    onClick={handlePrev}
                    className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4  vsm:px-6 px-8 rounded-md "
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3  vsm:px-4 px-6 rounded-md"
                  >
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "GUARDAR"
                        ) : (
                          "SAVE"
                        )}
                      </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
      <ToastContainer />
    </div>
  );
}
